/** Export menu entries shown under Shell toolbar → Export. */
export const shellExportMenuItems = [
  {
    key: 'exportExcel',
    label: 'Export CSV',
    tabs: ['table', 'departments', 'positions'],
  },
  {
    key: 'exportImage',
    label: 'Print current view',
    tabs: ['tree'],
  },
  {
    key: 'exportFullTree',
    label: 'Download full tree HTML',
    tabs: ['tree'],
  },
];
